module.exports = __webpack_public_path__ + "img/solvit_logo_white.68873cc8.png";